var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "media-library-item",
    {
      staticClass: "media-library-folder",
      attrs: {
        "name-editor-placeholder": _vm.resource(
          "MediaLibrary_RenameFolder_Placeholder"
        ),
        name: _vm.name
      },
      on: {
        "item-clicked": function($event) {
          return _vm.$emit("folder-selected")
        },
        "item-double-clicked": function($event) {
          return _vm.$emit("folder-navigated")
        },
        "item-renamed": function($event) {
          return _vm.rename($event)
        }
      }
    },
    [_c("i", { staticClass: "far fa-folder-open fa-3x" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }